<template>
  <div
    :class="[ open ? 'open' : '']"
    class="rexer-event_dropdown"
    @click="toggleDropdown()"
  >
    <span>
      {{ selection }}
    </span>
    <div
      class="rexer-event_dropdown-content"
      @mouseleave="open=false"
    >
      <a
        v-for="(item, index) in locations"
        :key="index"
        href="#"
        @click.prevent="selectionHandle(item)"
      >
        {{ item.label }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventLocation',
  props: {
    locations: {
      type: Array,
      required: true
    },
    selection: {
      type: String,
      default: 'Choose a Location'
    }
  },
  data () {
    return {
      open: false
    }
  },
  methods: {
    toggleDropdown () {
      this.open = !this.open
    },
    selectionHandle (item) {
      // this.$emit('locationChooseHandle', item )
      this.$geb.emit({ id: 'locationFilter', payload: Object.assign({}, { item }) })
    }
  }
}
</script>

<style lang="scss" scoped>
  $black: #000;
  $purple: #b004ff;
  $blue: #0248ff;
  $green: #00ff00;
  $color-active: #fff;
  .rexer-event_dropdown {
    $self: &;
    position: relative;
    background: transparent;
    padding: 0.25rem 3rem 0.25rem 2rem;
    display: block;
    text-align: center;
    font-weight: bold;
    font-size: 1rem;
    border: 4px solid $black;
    transition: all 330ms ease;
    cursor: pointer;
    &:after {
      content: '';
      position: absolute;
      right: 0.875rem;
      top: 1rem;
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 8px solid #000;
      clear: both;
    }
    span{
      display: block;
      color: $black;
      padding: 0.25rem 1rem;
      position: relative;
    }
    &-content {
      position: absolute;
      background-color: #f9f9f9;
      min-width: 320px;
      box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
      padding: 12px 16px;
      z-index: 1;
      left: 0;
      opacity: 0;
      display: none;
      > a{
        padding: 0.5rem 1rem;
        display: block;
        text-align: center;
        font-weight: bold;
        font-size: 1rem;
        text-align: left;
        line-height: 2;
        border-bottom: 1px solid #e4e4e4;
        &:hover, &:active, &:focus {
          background-color: #f9f9f9;
        }
        &:last-child{
          border: 0;
        }
      }
    }

    &.open {
      #{ $self }-content {
        opacity: 1;
        display: block;
      }
    }
  }
</style>
